import { tabs } from '@app/constants/app';
import { TabType, TabsType } from '@app/utils/types';

function isTabType(v: string | null | undefined): v is TabType {
  return v === TabsType.pastSprints || v === TabsType.currentSprint;
}

/** `?tab=` on first load, then optional location state (e.g. return from product detail). */
export function getReportingListInitialTab(
  search: string,
  fromLocationState: { activeTab?: TabType } | undefined,
): TabType {
  const fromUrl = new URLSearchParams(search).get('tab');
  if (isTabType(fromUrl)) return fromUrl;
  const fromState = fromLocationState?.activeTab;
  if (isTabType(fromState)) return fromState;
  return tabs.currentSprint;
}
